import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApplicationMeasureCategory,
  TechnicalMeasureCategoryCreateRequest,
  TechnicalMeasureCategoryCreateResponse,
  TechnicalMeasureCategoryDetails,
  TechnicalMeasureCategoryUpdateRequest,
  TechnicalMeasureCategoryUpdateResponse
} from '@ms-organization-entities';
import { CategoryMeasureDependency, PriorityPatchRequest } from '@primatoo-ms-organization';
import { ApiClientConfig } from '../api-client-config';
import { DataProtectionGovernanceService } from '../interface/data-protection-governance-service';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class TechnicalMeasureCategoryService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/technical-measure-categories/';
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<ApplicationMeasureCategory> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<ApplicationMeasureCategory>(url, request);
  }

  public getTechnicalMeasureCategories(): Observable<ApplicationMeasureCategory[]> {
    const url = this.endpoint;
    return this.httpClient.get<ApplicationMeasureCategory[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public getTechnicalMeasureCategoryById(id: number): Observable<ApplicationMeasureCategory> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<ApplicationMeasureCategory>(url);
  }

  public getTechnicalMeasureCategoryDetails(id: number): Observable<TechnicalMeasureCategoryDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<TechnicalMeasureCategoryDetails>(url);
  }

  public createTechnicalMeasureCategory(requestBody: TechnicalMeasureCategoryCreateRequest): Observable<TechnicalMeasureCategoryCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<TechnicalMeasureCategoryCreateResponse>(url, requestBody);
  }

  public updateTechnicalMeasureCategory(id: number, requestBody: TechnicalMeasureCategoryUpdateRequest): Observable<TechnicalMeasureCategoryUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<TechnicalMeasureCategoryUpdateResponse>(url, requestBody);
  }

  public getDependency(id: number): Observable<CategoryMeasureDependency> {
    const url = this.endpoint + `${id}/dependency`;
    return this.httpClient.get<CategoryMeasureDependency>(url);
  }

  public getEndPointV1(): string {
    return this.endpoint;
  }

  public getGroups(): Observable<string[]> {
    const url = this.endpoint + 'groups/';
    return this.httpClient.get<string[]>(url);
  }
}
